import { defineStore } from 'pinia';
import { ofetch } from 'ofetch';

export const useCasinoBonusesStore = defineStore('casinoBonuses', {
  state: () => ({
    bonuses: [],
    loaded: false,
  }),
  getters: {
    hasActiveBonuses: (state) => !state.loaded || state.bonuses.length > 0,
  },
  actions: {
    async fetchBonuses() {
      if (this.loaded) return;
      try {
        const data = await ofetch('/api/casino-bonuses', {
          baseURL: useNuxtApp().$apiUrl,
          credentials: 'include',
          headers: {
            Accept: 'application/json',
            'X-XSRF-TOKEN': useCookie('XSRF-TOKEN').value,
          },
        });
        this.bonuses = data;
      } catch (e) {
        // Silent fail — not logged in or no bonuses
      } finally {
        this.loaded = true;
      }
    },
    reset() {
      this.bonuses = [];
      this.loaded = false;
    },
  },
});
